/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { addressInputDataCountrySchema } from './AddressInputDataCountrySchema'

export const addressInputDataSchema = z.object({
	line1: z.string(),
	line2: z.string().nullable().optional(),
	city: z.string().nullable().optional(),
	state: z.string().nullable().optional(),
	postalCode: z.string(),
	country: addressInputDataCountrySchema,
})

export type AddressInputDataSchema = z.infer<typeof addressInputDataSchema>
